module.exports = __webpack_public_path__ + "img/bg_hexagon_blue.1c79e516.png";